import { render, staticRenderFns } from "./DefaultRoutes.vue?vue&type=template&id=99ef3344"
import script from "./DefaultRoutes.vue?vue&type=script&lang=js"
export * from "./DefaultRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports